module.exports = __webpack_public_path__ + "static/media/YB5M16_1.048015d1.jpg";